// https://developer.mozilla.org/en-US/docs/Web/API/CloseEvent

enum WS_CODE {
    NORMAL_CLOSURE = 1000,
    GOING_AWAY = 1001,
    CLOSURE_NO = 1005,
    ABNORMAL_CLOSURE = 1006
}
export default WS_CODE;